/**
 * Resolver URL gambar untuk sip-mon.
 *
 * - inventaris aset → /api/storage/{filename}
 * - perawatan aset  → /uploads/perawatan/{filename}
 * - perawatan bangunan → /uploads/bangunan/{filename}
 */

export function resolveMediaUrl(base, file) {
  if (!file || typeof file !== 'string') return null;
  const trimmed = file.trim();
  if (!trimmed || trimmed === 'null' || trimmed === 'undefined') return null;

  if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith('data:')) {
    return trimmed;
  }

  const root = (base || '').replace(/\/?$/, '/');
  let path = trimmed.startsWith('/') ? trimmed.slice(1) : trimmed;

  // Jika DB sudah menyimpan path relatif lengkap
  if (path.startsWith('uploads/') || path.startsWith('api/storage/')) {
    const apiOrigin = root
      .replace(/uploads\/$/, '')
      .replace(/api\/storage\/$/, '');
    return `${apiOrigin}${path}`;
  }

  // Hindari double folder (perawatan/perawatan/...)
  const folderMatch = root.match(/\/(uploads\/[^/]+|api\/storage)\/$/);
  if (folderMatch) {
    const folder = folderMatch[1];
    if (path.startsWith(`${folder}/`)) {
      const apiOrigin = root.replace(new RegExp(`${folder}/$`), '');
      return `${apiOrigin}${path}`;
    }
  }

  return `${root}${path}`;
}
